<template>
  <div>
    <div class="text-subtitle-1 mb-2">{{ label }}</div>
    <div v-if="subtitle" class="text-caption text--secondary mb-2">
      {{ subtitle }}
    </div>
    <v-radio-group v-model="noDeletion" row @change="onNoDeletionChange">
      <v-radio :value="true" :label="$t('global.retention-policy.no-deletion')">
      </v-radio>
      <v-radio
        :value="false"
        :label="$t('global.retention-policy.delete-after-label')"
      >
      </v-radio>
    </v-radio-group>

    <v-row v-if="!noDeletion">
      <v-col cols="3">
        <v-text-field
          v-model.number="localValue"
          type="number"
          :min="1"
          :rules="[minValueRule]"
          outlined
          dense
          @input="emitUpdate"
        >
        </v-text-field>
      </v-col>
      <v-col cols="3">
        <v-select
          v-model="localUnit"
          :items="units"
          outlined
          dense
          @change="emitUpdate"
        >
        </v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "RetentionCategoryInput",

  props: {
    label: String,
    subtitle: String,
    value: Object,
  },

  data() {
    return {
      noDeletion: this.value?.noDeletion ?? true,
      localValue: this.value?.value ?? 30,
      localUnit: this.value?.unit ?? "DAYS",
      units: [
        { text: this.$t("global.retention-policy.unit.days"), value: "DAYS" },
        {
          text: this.$t("global.retention-policy.unit.months"),
          value: "MONTHS",
        },
        { text: this.$t("global.retention-policy.unit.years"), value: "YEARS" },
      ],
      minValueRule: (v) =>
        v >= 1 || this.$t("global.validation.min-value", [1]),
    };
  },

  watch: {
    value: {
      handler(newVal) {
        this.noDeletion = newVal?.noDeletion ?? true;
        this.localValue = newVal?.value ?? 30;
        this.localUnit = newVal?.unit ?? "DAYS";
      },
      deep: true,
    },
  },

  methods: {
    onNoDeletionChange() {
      this.emitUpdate();
    },

    emitUpdate() {
      this.$emit("input", {
        value: this.noDeletion ? null : this.localValue,
        unit: this.noDeletion ? null : this.localUnit,
        noDeletion: this.noDeletion,
      });
    },
  },
};
</script>
